"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthentication = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useAuthentication = function useAuthentication(ssoScriptUrl, clientId) {
  var _useState = (0, _react.useState)({
    isAuthenticated: false,
    isAuthenticating: true,
    authCode: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      auth = _useState2[0],
      setAuth = _useState2[1];

  (0, _react.useEffect)(function () {
    return startAuthentication(ssoScriptUrl, clientId, setAuth);
  }, []);
  return auth;
};

exports.useAuthentication = useAuthentication;

function startAuthentication(ssoScriptUrl, clientId, setAuth) {
  var script = document.createElement("script");
  script.src = ssoScriptUrl;
  script.async = true;

  script.onload = function () {
    console.log("Script loaded");
    window.authSession.addLoginListeners(function (msg) {
      return authSuccess(msg, setAuth);
    }, function (msg) {
      return authFailure(msg, setAuth);
    });
    console.log("Attached login listeners, going to check authentication status");
    window.authSession.onReady(function () {
      return window.authSession.isAuthenticated(clientId);
    });
    console.log("Requested the authentication status");
  };

  document.body.appendChild(script);
  return function () {
    return window.authSession.removeLoginListeners();
  };
}

function authSuccess(msg, setAuth) {
  var _authStatus = {
    authCode: msg.code,
    isAuthenticated: true,
    isAuthenticating: false,
    accessToken: msg.access_token,
    userId: msg.user_id,
    userEmail: msg.user_email
  };
  setAuth(_authStatus);
  console.log("Assigned status to authStatus: " + JSON.stringify(_authStatus));
}

function authFailure(msg, setAuth) {
  var _authStatus = {
    isAuthenticated: false,
    isAuthenticating: false,
    authCode: null
  };
  setAuth(_authStatus);
}